import { useState, useEffect, useCallback } from "react";
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import EditIcon from "@mui/icons-material/Edit";
import { Box, CircularProgress } from "@mui/material";
import { useApi } from "../../utils/Api";
import Translate from "../../utils/Translate";
import { formatDate } from "../../utils/dateTimeFormat";
import DotMenu from "../../components/DotMenu";
import FreeSampleEditDialog from "../../components/admin/free-samples/FreeSampleEditDialog";
import Preloader from "../../components/Preloader";

export default function FreeSamplesPage() {
  const api = useApi();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    const response = await api.fetch(
      `${import.meta.env.VITE_MAIN_URL}agreements/instructor-material/free-samples`,
      false,
      "GET",
    );
    if (Array.isArray(response)) {
      setRows(response);
    }
    setLoading(false);
  }, [api]);

  useEffect(() => {
    reload();
  }, [reload]);

  const columns = [
    { field: "partDescription", headerName: Translate.get("ServiceAgreement"), flex: 1 },
    { field: "name", headerName: Translate.get("Name"), flex: 1 },
    { field: "version", headerName: Translate.get("Version"), width: 120 },
    {
      field: "availableFromDate",
      headerName: Translate.get("AvailableFromDate"),
      width: 160,
      valueFormatter: (value) => formatDate(value),
    },
    {
      field: "availableUntilDate",
      headerName: Translate.get("AvailableToDate"),
      width: 160,
      valueFormatter: (value) => formatDate(value),
    },
    {
      field: "dotMenu",
      headerName: "",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      align: "right",
      renderCell: (params) => (
        <DotMenu
          horizontal
          content={[
            {
              icon: <EditIcon />,
              text: Translate.get("Modify"),
              dialogHeader: Translate.get("Modify"),
              component: <FreeSampleEditDialog row={params.row} onSaved={reload} />,
            },
          ]}
        />
      ),
    },
  ];

  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        {loading ? (
          <Preloader />
        ) : (
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.agreementPartFreeSampleId}
            disableRowSelectionOnClick
          />
        )}
      </Box>
    </>
  );
}
